<template>
  <div>
    <AdminPageWrapper v-if="isAdmin">
      <EntreprisePageWrapper />
    </AdminPageWrapper>
    <EntreprisePageWrapper v-else />
  </div>
</template>

<script>
import AdminPageWrapper from "@/components/AdminPageWrapper.vue";
import EntreprisePageWrapper from "@/components/EntreprisePageWrapper.vue";

export default {
  name: "PageGestionEntreprise",
  components: {
    AdminPageWrapper,
    EntreprisePageWrapper,
  },
  computed: {
    isAdmin() {
      return parseInt(sessionStorage.getItem("role")) === 1;
    },
  },
};
</script>
